import { Route } from "~/enums/route";
import { RouteHelper } from "~/helpers/routeHelper";
import { IProviderRoutes } from "~/interfaces/provider";
import { IServerData } from "~/interfaces/serverInterfaces";
import { HTTPMethod } from "~/providers/new/httpMethod";
import Provider from "../../../../common/providers/new/provider";
import { Constructor } from "../../../../global/constructor";
import EndPoint from "../../models/connections/endPoint";

interface IEndPointProviderRoutes {
  endPointTest: Route;
}

export default class EndPointProvider<T extends EndPoint = EndPoint> extends Provider<T> {
  routes: IProviderRoutes & IEndPointProviderRoutes;

  constructor(protected modelType: Constructor<T>,
              public modelRoot: string,
              public collectionRoot: string,
              protected endPointBase: string = 'organization/settings/connections/:connection_id/end_points') {
    super(modelType, modelRoot, collectionRoot, endPointBase);

    let newRoutes : IEndPointProviderRoutes = {
      endPointTest: Route.endPointTest,
    }
    Object.assign(this.routes, newRoutes);
  }

  replacer(route: string, obj: any, metadata: any = {}): string {
    return super.replacer(route, obj, metadata).replace(':connection_id', obj.connection_id || metadata.connection_id);
  }

  async run(endPoint: T, obj): Promise<IServerData> {

    const payload = {
      requestPayload: obj
    }

    return this.serverAction({
      endpoint: this.replace(RouteHelper.path({route: this.routes.endPointTest}), endPoint),
      method: HTTPMethod.POST,
      json: payload
    })
  }
}